
import Wall from './Wall';

import { Math as TMath } from 'three';

export default class WallMobile extends Wall
{
  constructor(obj, type, initial_x_pos, row_index)
  {
    super(obj, type, initial_x_pos, row_index);
  }

  get_camera_position()
  {
    return super.get_camera_position(20);
  }

  // old change texts opacity depending on the distance
  // update()
  // {
  // this.sibling.set_sibling_opacity((1 - this.hover_t) * 5);

  // let t = (Math.abs(CameraManager.current.position.z - this.text.position.z + 20)) / 30;
  // t = 1 - TMath.clamp(t, 0, 0.6);
  // // console.log(t);
  // t = EasingFunctions.ease_in_out_quint(t);
  // this.text.opacity = t;
  // }

  set_opacity(opacity)
  {
    super.set_opacity(opacity);

    // Light up
    this.obj.children[1].material.opacity = opacity;
    // Light bottom
    this.obj.children[2].material.opacity = opacity;
    // glass_background
    this.obj.children[3].material.opacity = opacity;
    // Line
    this.obj.children[4].material.opacity = opacity;
  }

  set_position(offset)
  {
    this.obj.position.y = offset;
  }

  set_sibling_position(offset)
  {
    this.sibling.obj.position.y = offset;
  }

  set_text_position(offset, t)
  {
    this.text.position.y = TMath.lerp(offset, this.text_y_position, t);
  }

  set_text(text)
  {
    this.text = text;
    this.initial_text_x_pos = text.position.y;

    this.text_y_position = this.type === 'left' ? 37 : 30;
    this.text_offset = 24;
  }

  show_info()
  {
    this.gradient_animator.from = 0.9;
    this.gradient_animator.to = 0;

    super.show_info();
  }

  hide_info()
  {
    this.gradient_animator.from = 0;
    this.gradient_animator.to = 0.9;

    super.hide_info();
  }
}
